import getPlans from './getPlans';
import participantData from './participant';
import getPhoneNumber from './getPhoneNumber';
import postPhoneNumber from './postPhoneNumber';
import putPhoneNumber from './putPhoneNumber';
import getEmailAddress from "./getEmailAddress";
import putEmailAddress from "./putEmailAddress";
import getClientProfile from "./getClientProfile";
import getPlansInfoData from "./getPlansInfoData";
import getPlansRulesData from "./getPlansRulesData";
import getParticipantBeneficiaryData from "./getParticipantBeneficiaryData";
import getBeneMcCAmishSwitchData from "./getBeneMcCAmishSwitchData";
import getProfileMfaData from "./getProfileMfaData";
import setAlwaysChallengeMfa from "./setAlwaysChallengeMfa";
import getTaxRateBrackets from "./getTaxRateBrackets";
import getPayFrequencyOptions from "./getPayFrequencyOptions";
import postClientProfile from "./postClientProfile";
import getRixScenario from "./getRixScenario";
import getCompensations from "./getCompensations";
import updateCompensations from "./updateCompensations";
import postRiSimulation from "./postRiSimulation";
import getPlanProfileOlaMessageData from "./getPlanProfileOlaMessageData";
import getParticipantConsents from "./getParticipantConsents";
import getParticipantTerminateOlaMessageData from "./getParticipantTerminateOlaMessageData";
import getActivationCode from "./getActivationCode";
import submitActivationCode from "./submitActivationCode";
import getOtherRetirementPlansData from "./getOtherRetirementPlansData"
import deleteServiceStatus from "./deleteServiceStatus";
import updateServiceStatus from "./updateServiceStatus";
import getServiceStatus from "./getServiceStatus";
import getDefinedBenefitParticipantBeneficiariesData from "./getDefinedBenefitParticipantBeneficiariesData";
import getPlanProducts from "./getPlanProducts";
import getServiceProducts from "./getServiceProducts";
import updateServiceProducts from "./updateServiceProducts";
import getSempraActivePlanNameOlaMsg from "./getSempraActivePlanNameOlaMsg";
import getSempraTerminatedPlanNameOlaMsg from "./getSempraTerminatedPlanNameOlaMsg"


export default {
    "getPlansData": getPlans,
    "getPersonalInformationData": participantData,
    "getPhoneNumber": getPhoneNumber,
    "postPhoneNumber": postPhoneNumber,
    "putPhoneNumber": putPhoneNumber,
    "getActivationCode": getActivationCode,
    "submitActivationCode": submitActivationCode,
    "getEmailAddress": getEmailAddress,
    "putEmailAddress": putEmailAddress,
    "getClientProfile": getClientProfile,
    "getReferenceTypeValues": getPayFrequencyOptions,
    "postClientProfile": postClientProfile,
    "getRixScenario": getRixScenario,
    "getCompensations": getCompensations,
    "updateCompensations": updateCompensations,
    "saveOrUpdateRiSimulation": postRiSimulation,
    "getPlansInfoData": getPlansInfoData,
    "getPlansRulesData": getPlansRulesData,
    "getParticipantBeneficiaryData": getParticipantBeneficiaryData,
    "getDefinedBenefitParticipantBeneficiariesData": getDefinedBenefitParticipantBeneficiariesData,
    "getBeneMcCAmishSwitchData": getBeneMcCAmishSwitchData,
    "getProfileMfaData": getProfileMfaData,
    "setAlwaysChallengeMfa": setAlwaysChallengeMfa,
    "getTaxRateBrackets": getTaxRateBrackets,
    "getPlanProfileOlaMessageData" : getPlanProfileOlaMessageData,
    "getParticipantConsents": getParticipantConsents,
    "getParticipantTerminateOlaMessageData": getParticipantTerminateOlaMessageData,
    "getOtherRetirementPlansData": getOtherRetirementPlansData,
    "getServiceStatus": getServiceStatus,
    "getSempraActivePlanNameOlaMsg":getSempraActivePlanNameOlaMsg,
    "getSempraTerminatedPlanNameOlaMsg":getSempraTerminatedPlanNameOlaMsg,
    "updateServiceStatus": updateServiceStatus,
    "deleteServiceStatus": deleteServiceStatus,
    "getPlanProducts": getPlanProducts,
    "getServiceProducts": getServiceProducts,
    "updateServiceProducts": updateServiceProducts
}